<script lang="ts">
  import AutoComplete from '$shared/atoms/AutoComplete/AutoComplete.svelte';
  import { onMount } from 'svelte';

  interface Props {
    list?: CommonList[];
    value?: string;
    onchange?: (schoolName: string) => void;
  }

  let { list = [], value = '', onchange }: Props = $props();

  let schoolName: string = $state();

  let autoCompleteElement: AutoComplete = $state();

  onMount(() => {
    schoolName = value || '';
    autoCompleteElement?.setValue(schoolName);
  });

  const dispatchChange = (): void => {
    onchange?.(schoolName);
  };

  const onClickSchoolName = (detail: CommonList | any): void => {
    schoolName = detail.label;
    dispatchChange();
  };

  const onSchoolNameInputCleared = (): void => {
    if (!schoolName) return;
    schoolName = '';
    dispatchChange();
  };

  const onSchoolCreate = (detail: any): void => {
    schoolName = detail;
    dispatchChange();
  };
</script>

<div class="school-input">
  <AutoComplete
    canCreate
    showCreateInfo
    bind:this={autoCompleteElement}
    name="schoolName"
    infoLabel="Click to add school"
    placeholder="Search or add school name"
    list={list || []}
    value={schoolName}
    onclick={onClickSchoolName}
    oncreate={onSchoolCreate}
    oncleared={onSchoolNameInputCleared}
  />
</div>
